import React, { useState } from 'react';
import { Input } from '../../ui/input';

import { Search, SlidersHorizontal, X } from 'lucide-react';
import { cn } from '../../../lib/utils';

const AdvancedSearchBar = ({ searchQuery, setSearchQuery, filters, setFilters, categories, entityColor: entityColor, placeholder = "Rechercher..." }) => {
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div className="space-y-2" data-testid="advanced-search">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9 pr-24 h-9 text-sm"
            data-testid="advanced-search-input"
          />
          {searchQuery && (
            <button onClick={() => setSearchQuery('')} className="absolute right-16 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
              <X className="w-3.5 h-3.5" />
            </button>
          )}
          <button
            onClick={() => setShowFilters(!showFilters)}
            className={cn("absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1 px-2 py-1 rounded text-[11px] font-medium transition-colors",
              showFilters ? "bg-amber-100 text-amber-700" : "bg-gray-100 text-gray-600 hover:bg-gray-200")}
            data-testid="toggle-filters-btn"
          >
            <SlidersHorizontal className="w-3 h-3" />
            Filtres
          </button>
        </div>
      </div>

      {showFilters && (
        <div className="p-3 bg-gray-50 border rounded-lg grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="filter-panel">
          {categories && (
            <select
              value={filters.categorie || ''}
              onChange={(e) => setFilters(f => ({ ...f, categorie: e.target.value }))}
              className="px-2 py-1.5 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-amber-500"
              data-testid="filter-category"
            >
              <option value="">Toutes categories</option>
              {categories.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          )}
          <select
            value={filters.statut || ''}
            onChange={(e) => setFilters(f => ({ ...f, statut: e.target.value }))}
            className="px-2 py-1.5 border border-gray-300 rounded text-xs"
            data-testid="filter-status"
          >
            <option value="">Tous statuts</option>
            <option value="en_attente">En attente</option>
            <option value="valide">Valide</option>
            <option value="rejete">Rejete</option>
            <option value="archive">Archive</option>
          </select>
          <select
            value={filters.type_fichier || ''}
            onChange={(e) => setFilters(f => ({ ...f, type_fichier: e.target.value }))}
            className="px-2 py-1.5 border border-gray-300 rounded text-xs"
            data-testid="filter-filetype"
          >
            <option value="">Tous types</option>
            <option value="pdf">PDF</option>
            <option value="image">Image</option>
            <option value="word">Word</option>
            <option value="excel">Excel</option>
          </select>
          <select
            value={filters.periode || ''}
            onChange={(e) => setFilters(f => ({ ...f, periode: e.target.value }))}
            className="px-2 py-1.5 border border-gray-300 rounded text-xs"
            data-testid="filter-period"
          >
            <option value="">Toute periode</option>
            <option value="7">7 derniers jours</option>
            <option value="30">30 derniers jours</option>
            <option value="90">3 derniers mois</option>
            <option value="365">Cette annee</option>
          </select>
          {Object.values(filters).some(v => v) && (
            <button
              onClick={() => setFilters({})}
              className="col-span-2 sm:col-span-4 text-xs text-amber-600 hover:text-amber-700 flex items-center justify-center gap-1 py-1"
              data-testid="clear-filters-btn"
            >
              <X className="w-3 h-3" /> Effacer les filtres
            </button>
          )}
        </div>
      )}
    </div>
  );
};

// === CATEGORY MANAGER (Super Admin) ===

export default AdvancedSearchBar;
